package xim.poc.game.configuration.v0.behaviors

import xim.poc.game.ActorState
import xim.poc.game.CombatBonusAggregate
import xim.poc.game.configuration.constants.SkillId
import xim.poc.game.configuration.constants.mskillFormationAttack_312
import xim.poc.game.configuration.constants.mskillSlingBomb_311

class MobAtomicClusterBehavior(actorState: ActorState): FamilyClusterController(actorState) {

    override fun getSkills(): List<SkillId> {
        return super.getSkills() - setOf(mskillSlingBomb_311, mskillFormationAttack_312)
    }

    override fun applyMonsterBehaviorBonuses(aggregate: CombatBonusAggregate) {
        aggregate.mobSkillFastCast -= 20
        aggregate.fastCast -= 35
        aggregate.haste -= 15
        aggregate.spellInterruptDown += 80
    }

}